<template>
    <div>
        <CommonPopupFrame :changeHeight="75" :closeCompleteAction="closeAction" :isOpen="isOpen" :changeBottom="0" :is-back-press-apply="true">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeAction" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">활동지역 설정하기</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">회원님이 주로 활동하는 장소를 설정하여<br>지도에서 회원님의 위치를 표시할 수 있습니다.</div>
                </div>
                <div style="padding: 0 12px;">
                    <div class="common_box">
                        <NewPlaceSearchSelector :placeInfo="placeInfo" :resetInfo="resetInfo" :detect-select="detectRegionSelect" style="flex:1; "></NewPlaceSearchSelector>
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="Object.keys(placeInfo).length !== 0" class="save_btn_active">저장하기</div>
                <div class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from "../modal/my/CommonPopupFrame";
import NewPlaceSearchSelector from '@/components/common/NewPlaceSearchSelector'
import { PROFILE_BOX_LIST } from '@/Constants'
import ResponseCode from "@/ResponseCode"

export default {
    name: "SettingPlacePopup",
    components: { CommonPopupFrame, NewPlaceSearchSelector },
    props: {

    },
    data() {
        return {
            isOpen: false,
            placeInfo: {},
            PROFILE_BOX_LIST: PROFILE_BOX_LIST
        }
    },
    methods: {
        closeAction() {
            if (this.isOpen) {
                this.isOpen = false;
                return;
            }
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        ActBeforeClose() {
            this.isOpen = false;
        },
        detectRegionSelect(placeInfo) {
            this.placeInfo = placeInfo
        },
        resetInfo() {
            this.placeInfo = {}
        },
        async save() {
            if (Object.keys(this.placeInfo).length === 0) {
                this.$GlobalStore.showAlert('장소를 입력해주세요.');
                return;
            }
            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('place_id', this.placeInfo.id)
            formData.append('place_gps_latitude', this.placeInfo.gps_latitude)
            formData.append('place_gps_longitude', this.placeInfo.gps_longitude)
            formData.append('place_name', this.placeInfo.name)
            formData.append('place_address', this.placeInfo.address)

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.placeInfo = {}
                this.$GlobalStore.hideProgress()
                this.closeAction()
            }
        },
    },
    mounted() {
        setTimeout(() => {
            this.isOpen = true;
        }, 100)
    },
    created() {
        this.save = this.$Once(this.save)
        //this.$GlobalStore.addModal('TestModal', {transitionName : '', isModalBackTransparent : true});
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}
</style>